module.exports = __webpack_public_path__ + "img/empty.038e5d22.png";